import { render, staticRenderFns } from "./Valores.vue?vue&type=template&id=f1242c08&scoped=true"
var script = {}
import style0 from "./Valores.vue?vue&type=style&index=0&id=f1242c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1242c08",
  null
  
)

export default component.exports